module.exports = __webpack_public_path__ + "static/media/ic_trash-red.a0dd4068.svg";